export const textSwe=[
"Hur gör jag?",
"Välj och klicka på en riksdagsledamot här nedan som inte redan har svarat.",
"Kopiera text och rubrikrad på ledamotens sida och mejla det till riksdagsledamoten från din egen e-post.",
"Om tillräckligt många riktar frågan, så kan vi tillsammans få riksdagsledamöterna att svara.",
"Det färdigskrivna e-postmeddelandet kan du läsa ",
"här.",
" av 349 riksdagsledamöter har svarat",    
]